import React, { useState, Key, useEffect } from "react";
import styled from "styled-components";
import { Menu, Table, Tag, Dropdown, Space } from "antd";
import type { ColumnsType } from "antd/es/table";
import { MoreOutlined } from "@ant-design/icons";
import { ProjectPendingDataType } from "../Types/DataType";
import { isAuth } from "../../../auth/ProtectedRoute";
import SkeletonTable, {
  SkeletonTableColumnsType,
} from "../../../../components/SkeletonTable";
import axios from "axios";
import ViewPendingProjectBtn from "../components/ViewProjectBtn";
import DeleteProjectModal from "../components/DeleteProjectModal";
import { CircularProgress, Box } from "@mui/material";

const ProjectPendingTable = (props: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [projectTableData, setProjectTableData] = useState<
    ProjectPendingDataType[]
  >([]);
  const [showTotal, setShowTotal] = useState<number>();
  const [record, setRecord] = useState<ProjectPendingDataType>();

  const menu = (
    <Menu
      items={[
        {
          label: <ViewPendingProjectBtn record={record!} />,
          key: "1",
          icon: <i className="fa fa-eye" aria-hidden="true"></i>,
        },
        {
          label: <DeleteProjectModal record={record!} />,
          key: "2",
          icon: <i className="fa fa-trash" aria-hidden="true"></i>,
        },
      ]}
    />
  );

  //api request for table data
  const showProjectTable = (page: number) => {
    setLoading(true);
    axios({
      method: "GET",
      url: process.env.REACT_APP_HOST_API + `projects/pending?page=${page}`,
      headers: {
        Authorization: `Bearer ${isAuth()}`,
      },
    })
      .then((res) => {
        setLoading(false);
        if (res.data.response === true && res.data.status === 200) {
          // console.log("ress", res);

          setProjectTableData(
            res.data.data.data.map((projectData: any) => ({
              key: projectData.id,
              id: projectData.id,
              buyer: {
                fullname: projectData?.member?.fullname || projectData.fullname || "N/A",
                image: projectData.buyer_profile_image
                  ? process.env.REACT_APP_IMAGE_API_PREFIX + projectData.buyer_profile_image
                  : null,
              },
              title:
                projectData.title.length > 20
                  ? `${projectData.title.slice(0, 20)}...`
                  : projectData.title,
              type: projectData.type,
              status: "Pending",
              action: "",
            }))
          );
          setShowTotal(res?.data?.data?.data?.length || 0);
          props.getPendingTotal(res?.data?.data?.data?.length || 0);
        } else {
          // console.log(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    showProjectTable(1);
  }, []);

  const columns: ColumnsType<ProjectPendingDataType> = [
    {
      title: "Name",
      dataIndex: "buyer",
      render: ({ fullname, image }) => (
        <div className="user-area" style={{ alignItems: "center", display: "flex" }}>
          {image ? (
            <ImageContainer style={{ marginRight: "20px" }}>
              <img
                src={image}
                alt="user"
                className="user_avatar"
                style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }}
              />
            </ImageContainer>
          ) : (
            <div
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                backgroundColor: "#4895ef",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
                fontWeight: 600,
                fontSize: "16px",
                marginRight: "20px",
                flexShrink: 0,
              }}
            >
              {fullname?.charAt(0)?.toUpperCase() || "?"}
            </div>
          )}
          <p className="user_name" style={{ margin: 0, fontWeight: 500 }}>{fullname}</p>
        </div>
      ),
    },
    {
      title: "Project Title",
      dataIndex: "title",

      render: (text) => (
        <div>
          <p className="user_name">{text}</p>
        </div>
      ),
    },
    {
      title: "Project Type",
      dataIndex: "type",
      render: (text) => (
        <div>
          <p className="user_name">{text}</p>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <Tag color="green" style={{ borderRadius: "10px", padding: "2px 10px" }}>
          {text}
        </Tag>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <Space wrap>
          <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
            <MoreOutlined style={{ fontSize: "20px", cursor: "pointer" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  // rowSelection object indicates the need for row selection
  // const rowSelection = {
  //   onChange: (
  //     selectedRowKeys: Key[],
  //     selectedRows: ProjectPendingDataType[]
  //   ) => {
  //     console.log(
  //       `selectedRowKeys: ${selectedRowKeys}`,
  //       "selectedRows: ",
  //       selectedRows
  //     );
  //   },
  //   // getCheckboxProps: (record: ProjectPendingDataType) => ({
  //   //   disabled: record === "Disabled User", // Column configuration not to be checked
  //   //   name: record.buyer,
  //   // }),
  // };
  // const [selectionType, setSelectionType] = useState<"checkbox" | "radio">(
  //   "checkbox"
  // );

  return (
    <SkeletonTable
      loading={loading}
      columns={columns as SkeletonTableColumnsType[]}
    >
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
          }}
        >
          <CircularProgress size={40} thickness={4} style={{ color: "#4895ef" }} />
        </Box>
      ) : (
        <Table
          columns={columns}
          dataSource={projectTableData}
          pagination={{
            showSizeChanger: false,
            pageSize: 50,
            total: showTotal,
            onChange: (page) => {
              showProjectTable(page);
            },
            showTotal: (showTotal, range) =>
              `${range[0]}-${range[1]} of ${showTotal} items`,
          }}
          onRow={(record) => {
            return {
              onClick: () => {
                setRecord(record);
              },
            };
          }}
        />
      )}
    </SkeletonTable>
  );
};

export default ProjectPendingTable;

const ImageContainer = styled.div`
  height: 45px;
  width: 45px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
